import { Component, OnInit } from '@angular/core';
import { AppServiceService } from '../../app-service.service';
import { UiService } from '../../ui.service';
import { menuAnimate, submenuAnimate } from '../../animation/animate';
import { ApiService } from '../../api.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  animations: [menuAnimate, submenuAnimate]
})
export class MenuComponent implements OnInit {
  private menuActive: boolean = false;
  private blackStyle:boolean;
  private normalMenu:boolean;
  private activeMenu: boolean = false;
  private themeDir:string = '';
  private widthDesc: boolean;
  private subMenu: boolean = false;
  private settings:any;
  private menuTop:boolean = false;
  public theme:any = {
    'social' : {
      'facebook' : '',
      'instagram': ''
    }
  };
  private submenuState: string = 'hide';
  public openPresentation: boolean = false;
  //animate state menu
  private menuState:string;

  toogleMenu(){
    this.menuState = this.menuState == 'hide' ? 'show' : 'hide';
    if(this.menuState == 'hide'){
      this.submenuState     = 'hide';
      this.openPresentation = false;
    }
  }

  constructor(
    private app:AppServiceService, 
    private UI:UiService,
    private api: ApiService,
    private router: Router
  ) {
    this.app.blackStyle.subscribe(data => {
      this.blackStyle = data;
    });
    this.app.normalMenu.subscribe(data => {
      this.normalMenu = data;
    });
    this.app.activeMenu.subscribe(data => {
      this.activeMenu = data;
    });
    this.app.positionMenuTop.subscribe(data => {
      this.menuTop = data;
    });
    this.api.getThemeSettings().subscribe(data => {
      this.theme = data;
    })
  }

  openSubMenu(){
    this.submenuState = this.submenuState == 'show' ? 'hide' : 'show';
    //this.UI.openSubMenu();
  }

  goHome(event){
    event.preventDefault();
    event.stopPropagation();

    if(window.location.pathname == '/'){
      this.UI.moveHomeSection();
      console.log('hash', window.location.hash);
    }

    this.router.navigate(['/' ], {fragment: 'home'});
  }

  openPress(){
    this.openPresentation = !this.openPresentation;
  }

  ngOnInit() {
    this.UI.mobileclickMenu();
    this.UI.leftPanelSingleCollection();
    this.api.getThemeSettings().subscribe((data) => {
      this.settings = data;
    })
    this.UI.menuCaret();
    this.UI.menuScripts();
    this.app.menuState.subscribe(data => {
      this.menuState = data;
    });
    this.app.submenuState.subscribe(data => {
      this.submenuState = data;
    });
    this.widthDesc = this.UI.getWidth();
  }

}



// WEBPACK FOOTER //
// ./src/app/common/menu/menu.component.ts